import { defineMessages } from 'react-intl'

const messages = {
  ends: {
    id: 'app.components.time-status.ends',
    defaultMessage: 'Ends',
  },
  cycleEnded: {
    id: 'app.components.time-status.cycle-ended',
    defaultMessage: 'Cycle ended',
  },
}

export default defineMessages(messages)
